import { useContext, useEffect, useState } from "react"
import { ItemsContext } from "../contexts/ItemsContext"
import LogoNavbar from "./LogoNavbar"
import { toast } from "react-toastify"


const Logout=()=>{

    const {logoutUser,loggedInUser,setLoggedInUser,setLogin}=useContext(ItemsContext)
    const [time, setTime] = useState(new Date())

    useEffect(() => {
        const interval = setInterval(() => {
          setTime(new Date());
        }, 1000);
    
        return () => clearInterval(interval);
      }, [])

    const handleClick=()=>{
        if(window.confirm("Are you sure you WANT TO LOG OUT? Confirm and log out."))
        logoutUser() 
           // setTimeout(()=>alert("The user has LOGGED OUT."),100)    
    }
    const handleClick2=()=>{
        localStorage.removeItem("users")
        localStorage.removeItem("items") 
        setLoggedInUser(null)
        setLogin(false)
        alert("All users data has been DELETED.\nYou will be now REDIRECT to Introduction page.")     
    }  
//REMAINS KEYS WITH EMPTY ARRAYS OF USERS AND ITEMS, because of initializing in useEffect in global context...//
const handleClick3=()=>{
    toast.info("Welcome to Help Info. You can add, edit, view, and delete items. Data is saved to the browser's localStorage on your personal computer and will be stored permanently. To delete your saved data, click the red button. This will delete all of your saved data, including your sign-up and login information, from localStorage. This action cannot be undone. You can start over by signing up again to use the application. I hope you enjoy using it. Marek Loníček, email: mark.lonicek@seznam.cz", {
        position: "top-center",
        autoClose: 60000,
        hideProgressBar: false,
        theme: "light",
        closeOnClick: true,
      })
      
}
return(
        <div className="logout">
                <p><strong>Date:</strong> {new Date(Date.now()).toLocaleDateString("cs-CZ")}</p>
                <p id="time"><strong>Time:</strong> {time.toLocaleTimeString("cs-CZ")}</p>  
                <LogoNavbar onClick={handleClick3}/>
                <p id="username">Logged in as <strong>{loggedInUser}</strong></p>
                <button onClick={handleClick}>Log out</button>
                <div className="deleteData">
<button onClick={handleClick2}>Delete all users data</button>
</div>
           
        </div>
    )
}

export default Logout


